<div class="modal-header">
    <h4 *ngIf="soloDemo" class="modal-title">Contacto de Ayuda</h4>
    <h4 *ngIf="!soloDemo" class="modal-title">Contacto de Ayuda</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <h1 id="modal-title" *ngIf="soloDemo" class="m-3">Escríbenos a WhatsApp para ayudarte.</h1>
    <h1 id="modal-title" *ngIf="!soloDemo" class="m-3">Elija su método preferido para ayudarte.
    </h1>
    <div class="container">
        <div *ngIf="soloDemo" class="d-flex w-100 justify-content-center">
            <div class="d-flex flex-row flex-wrap gap-4">
                <img class="image-qr" [src]="'/assets/qr/ventas-qr-code.png'">
            </div>
        </div>

        <div *ngIf="!soloDemo" class="d-flex w-100 justify-content-center">
            <div class="d-flex flex-row flex-wrap gap-4">
                <img class="image-qr" [src]="'/assets/qr/support-qr-code.png'">
            </div>
        </div>

        <hr>

        <button *ngIf="!soloDemo" type="button" class="btn btn-primary btn-block w-100 my-2 py-2" (click)="email()">
            <i class="fa-solid fa-envelope me-2"></i> Correo Electrónico a soporte&#64;kuvemar.com
        </button>

        <button *ngIf="soloDemo" type="button" class="btn btn-success btn-block w-100 my-2 py-2" (click)="whatsApp()">
            <i class="fa-brands fa-whatsapp me-2"></i> WhatsApp +56 9 4475 8039
        </button>

        <button *ngIf="!soloDemo" type="button" class="btn btn-success btn-block w-100 my-2 py-2"
            (click)="whatsAppKuvemar()">
            <i class="fa-brands fa-whatsapp me-2"></i> WhatsApp +56 9 7981 3206
        </button>

        <div class="py-2 d-flex gap-2">
            <button *ngIf="showTutorialButton" class="btn btn-primary btn-block w-50 " (click)="iniciarTutorial()">
                <i class="fa-solid fa-circle-question me-2"></i> Iniciar tutorial
            </button>
            <button *ngIf="showTutorialButton" class="btn btn-primary btn-block w-50 " (click)="verTutoriales()">
                <i class="fa-solid fa-play-circle me-2"></i> Videos y módulos
            </button>
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelar()"> Cerrar</button>
</div>